import {DtoMapper} from '@wemogy/reactbase';
import { IProcessingTemplate } from '../../../ui/wrappers/formBuilder/dataLayer/models/ProcessingTemplate';

export default class ProcessingTemplateDtoMapper extends DtoMapper<IProcessingTemplate, any>{

}
